import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { cloneDeep, isEmpty, uniqueId } from 'lodash';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { Listings } from 'containers/AppContainer/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import JudgementAddForm from 'containers/LawyerLegalProceedingsPage/AppealAdd/AppealAddPronouncing/AppealAddForm';
import { EMPTY_ADD } from 'containers/data-structure';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Forms } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/styled-components';
import JudgementAddPronouncingRecap from 'containers/LawyerLegalProceedingsPage/AppealAdd/Recap';
import { AppealAddDocType } from 'containers/LawyerLegalProceedingsPage/AppealAdd/constants';
import { isDuplicateJudgementsAdd } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { translate } from 'containers/services/translate';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import { VictimType } from 'typings/globalTypes';
export interface JudgementAddPronouncingFormsProps {
  intl: IntlShape;
  listings: Listings;
  victims: VictimType[];
  vehicules: Vehicule[];
  judgementAddDocuments: JudgementADDDocumentType[];
  setJudgementAddDocuments: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  document: AppealAddDocType;
  setDocument: Function;
  details: any;
  setIsAddJudgementAddFormOn: React.Dispatch<React.SetStateAction<boolean>>;
  judiciaryProcessId?: number;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  claimAssignment: any;
  feeNotes: any;
  setOpenFeeNoteDialog: Function;
  imagineDocuments: any;
  claimId: number;
  policyInfo: any;
  requestGetDocByDocumentumId: Function;
}

const JudgementAddPronouncingForms: React.FC<JudgementAddPronouncingFormsProps> = (
  props,
): JSX.Element => {
  const [judgementAddPronouncings, setJudgementAddPronouncings] = useState<
    JudgementADDDocumentType[]
  >([cloneDeep(EMPTY_ADD) as any]);

  const [showDuplicateWarning, setShowDuplicateWarning] = useState<boolean>(
    false,
  );

  const handleChangeJudgementAddProunoucing = (index: number) => (
    judgement: JudgementADDDocumentType,
  ) => {
    const judgementADD = [...judgementAddPronouncings];

    if (!isEmpty(judgement)) {
      judgementADD[index] = judgement;
    } else {
      //handling the case when emptying state
      judgementADD.splice(index, 1);
    }

    setJudgementAddPronouncings(judgementADD);
  };

  const saveForm = (judgement: JudgementADDDocumentType) => {
    if (isDuplicateJudgementsAdd(judgement, props.judgementAddDocuments)) {
      return setShowDuplicateWarning(true);
    }
    const judgementADDDocuments = [...props.judgementAddDocuments];
    judgementADDDocuments.push(judgement);

    props.setJudgementAddDocuments(judgementADDDocuments);
    setShowDuplicateWarning(false);
  };

  const deleteJudgementAdd = (index: number) => () => {
    const judgementAddDocs = [...props.judgementAddDocuments];

    if (judgementAddDocs.length <= 1 && isEmpty(judgementAddPronouncings)) {
      props.setIsAddJudgementAddFormOn(false);
    }

    judgementAddDocs.splice(index, 1);
    props.setJudgementAddDocuments(judgementAddDocs);
  };
  const cancelJudgement = (index: number) => () => {
    let judgement = [...judgementAddPronouncings];

    if (
      isEmpty(props.judgementAddDocuments) &&
      judgementAddPronouncings.length === 1
    ) {
      props.setIsAddJudgementAddFormOn(false);
    } else {
      judgement.splice(index, 1);
      setJudgementAddPronouncings(judgement);
    }
  };

  return (
    <Forms>
      <div
        style={{
          margin: '5px',
          fontWeight: 'bold',
          fontSize: '18px',
          color: 'red',
        }}
      >
        {showDuplicateWarning
          ? translate(messages.duplicateJaddWarning, props)
          : ''}
      </div>
      {!isEmpty(props.judgementAddDocuments) &&
        props.judgementAddDocuments.map(
          (judgementAddDocument, index: number) => {
            return (
              <JudgementAddPronouncingRecap
                key={uniqueId('recap_')}
                listings={props.listings}
                judgementAddDocument={judgementAddDocument}
                index={index}
                deleteJudgementAdd={deleteJudgementAdd(index)}
                isManager={false}
                judiciaryProcessId={props.judiciaryProcessId}
                judgementAddDocumentIds={props.judgementAddDocuments.map(
                  item => item.id,
                )}
                sagisVictimInfo={props.sagisVictimInfo}
                sagisOpposingParties={props.sagisOpposingParties}
                claimAssignment={props.claimAssignment}
                feeNotes={props.feeNotes}
                setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
                isConsultation={false}
                policyInfo={props.policyInfo}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                uploadDocument={props.uploadDocument}
                setDocumentId={() => {}}
                uploadedDocument={props.uploadedDocument}
                resetUploadedDocument={props.resetUploadedDocument}
                setOpenInvoiceFeeNoteUpdateInfoDialog={() => {}}
                openInvoiceFeeNoteUpdateInfoDialog={false}
                handleValidateUpdateJudgementAddDocument={() => {}}
                setJudgemenAddDocumentToUpdate={() => {}}
              />
            );
          },
        )}
      {!isEmpty(judgementAddPronouncings) &&
        judgementAddPronouncings.map((judgement: any, index: number) => (
          <JudgementAddForm
            key={index}
            listings={props.listings}
            victims={props.victims}
            judgementAddPronouncing={judgement}
            vehicules={props.vehicules}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            handleSetJudgementAddPronouncing={handleChangeJudgementAddProunoucing(
              index,
            )}
            index={index}
            details={props.details}
            saveForm={saveForm}
            cancelJudgement={cancelJudgement(index)}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            imagineDocuments={props.imagineDocuments}
            claimId={props.claimId}
            policyInfo={props.policyInfo}
            isManager={userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCOURTMANAGER,
            )}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        ))}
    </Forms>
  );
};

export default injectIntl(JudgementAddPronouncingForms);
